import React from 'react';
import { useSelector } from 'react-redux';
import { string } from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import classNames from 'classnames/bind';
import FreestarAd from '../FreestarAd/FreestarAdConnectLazy';
import { isCookieDisabled } from '../../helpers/Utils/parseOnetrust';
import { getFreestarAttributes } from '../../helpers/Utils/freestarUtils';
import { OPTANON_COOKIE, TRACKING } from '../../helpers/Utils/parseOnetrustConfig.config';
import { selectFeatureFlags } from '../../selectors/ContextSelector';
import * as styles from './displayAds.css';

const cx = classNames.bind(styles);

const CMDisplayAds = ({ adId, automationId }) => {
    const featureFlags = useSelector((state) => selectFeatureFlags(state));
    const { enableFreestarAdComponent = false } = featureFlags;
    const isTrackingCookieActive = !isCookieDisabled(TRACKING, OPTANON_COOKIE);
    const adClasses = `${dt(['text-center'])} ${cx('container')}`;
    const { context: { requestUrl = '' } = {} } = useSelector((context) => context);
    const { channel, freestarAdId } = getFreestarAttributes(adId, requestUrl);

    return (
        enableFreestarAdComponent &&
        isTrackingCookieActive && (
            <FreestarAd
                automationId={automationId}
                className={adClasses}
                placementName={freestarAdId}
                channel={channel}
            />
        )
    );
};

CMDisplayAds.defaultProps = {
    adId: '',
    automationId: '',
};

CMDisplayAds.propTypes = {
    adId: string,
    automationId: string,
};

export default CMDisplayAds;
